import { v4 as uuidv4 } from "uuid";
export class PMOTeamApexProjectGridViewModel {
    constructor() {
        this.projectId = uuidv4();
        this.projectName = "";
        this.description = "";
        this.ownerId = "";
        this.ownerName = "";
        this.ownerImageURL = "";
    }
}
export default class PMOTeamApexProjectGridView extends PMOTeamApexProjectGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
